import React from "react";
import ClientsListView from "./ClientsListView/ClientsListView";
import { useClients, useClientsExtend } from "../../../hooks/useClients";
import { LoaderSreen } from "../../../../../common/components/molecule/Loader/Loader";
import ErrorScreenApp from "../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";

import SingleOrganization from "../../../../organization/components/SingleOrganization";
import Pagination from "../../../../../common/components/organisme/Pagination/Pagination";
import { dateConverter } from "../../../../../utils/dateConverter";
import useNavigationApp from "../../../../../navigation/useNavigationApp";

export default function ClientsListPresenter() {
  const { allClientsQuery } = useClients({ pageSize: 8 });
  const navigate = useNavigationApp();

  if (allClientsQuery.isError) {
    return <ErrorScreenApp axiosError={allClientsQuery.error} />;
  }

  const content = allClientsQuery.data?.data?.map((client) => ({
    id: client.client_id,
    firstName: client.client_firstname,
    lastName: client.client_lastname,
    organizationRender: () => (
      <SingleOrganization.Info
        id={client.organization_id}
        info="organization_name"
      />
    ),
    createdAt: dateConverter(client.client_created_at),
    onClick: () => {
      navigate.goToSingleClient(client.client_id);
    }

  }));

  const pagination = allClientsQuery.data?.pagination;

  return allClientsQuery.isLoading ? (
    <LoaderSreen heigth={"100px"} />
  ) : (
    <>
      <ClientsListView content={content} nbFound={allClientsQuery.data?.pagination.total_count} />
      <Pagination
        centered
        currentPage={pagination?.current_page}
        setCurrentPage={allClientsQuery.setPage}
        lastPage={pagination?.total_pages}
      />
    </>
  );
}

export  function ClientsExtendListPresenter() {
  const { allClientsQuery } = useClientsExtend({pageSize: 8});
  const navigate = useNavigationApp();

  if (allClientsQuery.isError) {
    return <ErrorScreenApp axiosError={allClientsQuery.error} />;
  }

  const content = allClientsQuery.data?.data?.map((client) => ({
    id: client.client_id,
    firstName: client.client_firstname,
    lastName: client.client_lastname,
    organizationRender: () => (
      <SingleOrganization.Info
        id={client.organization_id}
        info="organization_name"
      />
    ),
    createdAt: dateConverter(client.client_created_at),
    onClick: () => {
      navigate.goToSingleClientExtend(client.user_orga_id);
    }

  }));

  const pagination = allClientsQuery.data?.pagination;

  return allClientsQuery.isLoading ? (
    <LoaderSreen heigth={"100px"} />
  ) : (
    <>
      <ClientsListView content={content} nbFound={allClientsQuery.data?.pagination.total_count} />
      <Pagination
        centered
        currentPage={pagination?.current_page}
        setCurrentPage={allClientsQuery.setPage}
        lastPage={pagination?.total_pages}
      />
    </>
  );
}
